var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27602 0.782282C5.56947 0.187684 6.41735 0.187686 6.7108 0.782282L7.82253 3.03489L10.3084 3.39611C10.9646 3.49146 11.2266 4.29784 10.7518 4.76067L8.95299 6.51408L9.37763 8.98994C9.48972 9.64346 8.80377 10.1418 8.21687 9.83328L5.99341 8.66434L3.76995 9.83328C3.18305 10.1418 2.4971 9.64346 2.60919 8.98994L3.03383 6.51408L1.23502 4.76067C0.760205 4.29784 1.02221 3.49146 1.67839 3.39611L4.16429 3.03489L5.27602 0.782282ZM5.99341 1.58824L5.01449 3.57175C4.89796 3.80786 4.67271 3.97152 4.41214 4.00938L2.22322 4.32745L3.80714 5.87139C3.99569 6.05518 4.08173 6.31998 4.03722 6.57949L3.6633 8.75957L5.62114 7.73028C5.8542 7.60775 6.13262 7.60775 6.36568 7.73028L8.32352 8.75957L7.9496 6.57949C7.90509 6.31998 7.99113 6.05518 8.17968 5.87139L9.7636 4.32745L7.57468 4.00938C7.31411 3.97152 7.08886 3.80786 6.97233 3.57175L5.99341 1.58824Z",
    fill: "#DD296E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.c8f559e4ff48b79e9bc21fa02be17526.svg";
export { ForwardRef as ReactComponent };